function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Radio Button component
 * 
 */
import * as React from 'react';
import ErrorMessage from '../error-message/ErrorMessage';
import Info from '../info/Info';
import './RadioButton.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class RadioButtons extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        handleChange
      } = this.props;
      const {
        focus
      } = this.state;
      if (focus && key === 'Enter') {
        handleChange(focus);
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", focus => {
      this.setState({
        focus
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: ''
      });
    });
    this.state = {
      focus: ''
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  renderButtons() {
    const {
      handleChange,
      name,
      options,
      values
    } = this.props;
    const {
      focus
    } = this.state;
    let buttons = [];
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const checked = values[name].value === option.value ? true : false;
      const highlight = checked ? ' highlight' : '';
      const selected = checked ? ' selected ' : '';
      const hasFocus = focus === option.value ? ' focus' : '';
      buttons.push(/*#__PURE__*/_jsxs("div", {
        className: `radiobutton-container${selected}${hasFocus}`,
        onClick: () => handleChange(option.value),
        tabIndex: "0",
        onFocus: () => this.onFocus(option.value),
        onBlur: this.onBlur,
        children: [/*#__PURE__*/_jsx("input", {
          id: option.value,
          className: "radio-button-hidden",
          type: "radio",
          checked: checked,
          value: option.value,
          onChange: () => handleChange(option.value)
        }), /*#__PURE__*/_jsxs("label", {
          htmlFor: option.value,
          children: [/*#__PURE__*/_jsx("div", {
            className: "radio-display",
            children: /*#__PURE__*/_jsx("div", {
              className: `inner${highlight}`
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "radio-text",
            children: [option.icon ? option.icon : null, option.title]
          })]
        })]
      }, option.value));
    }
    if (buttons.length > 0) {
      return /*#__PURE__*/_jsx("div", {
        className: "radio-buttons",
        children: buttons
      });
    }
    return null;
  }
  render() {
    const {
      label,
      info,
      name,
      values
    } = this.props;
    const {
      error,
      required,
      valid
    } = values[name];
    const classes = `form-element-container ${name}${error ? ' error' : ''}`;
    const errorMessage = valid === null ? `${label} is required` : valid === false ? `${label} is not valid` : '';
    return /*#__PURE__*/_jsxs("div", {
      className: classes,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "label",
        children: [label, required ? /*#__PURE__*/_jsx("span", {
          className: "required",
          children: "*"
        }) : '']
      }), this.renderButtons(), info.length > 0 ? /*#__PURE__*/_jsx(Info, {
        info: info
      }) : null, /*#__PURE__*/_jsx(ErrorMessage, {
        message: errorMessage,
        error: error
      })]
    });
  }
}
_defineProperty(RadioButtons, "defaultProps", {
  info: '',
  label: 'Do you wear glasses while driving',
  name: 'wearGlasses',
  options: [{
    default: true,
    title: 'No',
    value: 'No',
    icon: null
  }, {
    default: false,
    title: 'Yes',
    value: 'Yes',
    icon: null
  }],
  required: false,
  section: 'license-details',
  values: {
    wearGlasses: {
      error: false,
      required: false,
      valid: false,
      value: 'No'
    }
  }
});
export default RadioButtons;